function EntityToolbar({ activeView, onChangeView, entityLabel = 'Supplier' }) {
  return (
    <div className="inline-flex w-fit max-w-full flex-wrap gap-1 rounded-[18px] border border-[var(--theme-border)] bg-[var(--theme-accent-soft)] p-1 shadow-[inset_0_1px_0_rgba(255,255,255,0.68)]">
      <ToolbarButton
        isActive={activeView === 'list'}
        label={`${entityLabel} List`}
        onClick={() => onChangeView('list')}
      />
      <ToolbarButton
        isActive={activeView === 'create'}
        label={`Add ${entityLabel}`}
        onClick={() => onChangeView('create')}
      />
    </div>
  );
}

function ToolbarButton({ isActive, label, onClick }) {
  return (
    <button
      className={`inline-flex min-h-[44px] items-center justify-center rounded-[14px] px-5 text-[0.94rem] font-semibold outline-none transition focus-visible:ring-2 focus-visible:ring-[var(--theme-focus)] focus-visible:ring-offset-2 focus-visible:ring-offset-[#f5f0ea] sm:px-6 ${
        isActive
          ? 'bg-white text-[var(--theme-text)] shadow-[0_10px_22px_rgba(var(--theme-shadow-rgb),0.14)] ring-1 ring-[var(--theme-border)]'
          : 'text-[var(--theme-text-subtle)] hover:bg-white/55 hover:text-[var(--theme-text-strong)]'
      }`}
      type="button"
      onClick={onClick}
      aria-pressed={isActive}
    >
      {label}
    </button>
  );
}

export default EntityToolbar;
